/**
 * Interceptor global de fetch, con 2 funciones:
 *
 * 1. Sesión deslizante: si el backend manda un token renovado en el header
 *    "X-New-Token" (porque al token anterior le quedaba poca vida), lo
 *    guarda solo en localStorage — sin que el usuario note nada, sin
 *    cerrar sesión, sin recargar la página.
 *
 * 2. Red de seguridad: si de verdad el token venció o es inválido (401),
 *    borra la sesión y manda al usuario al login — en vez de dejar que
 *    cada pantalla muestre un error confuso ("no se pudo cargar", etc.)
 *    que en realidad es solo que la sesión expiró.
 *
 * Se activa una sola vez, importando este archivo al principio de App.tsx
 * (import './authInterceptor';), y de ahí en adelante protege TODAS las
 * llamadas fetch de todas las pantallas, sin tener que tocar cada una.
 */

const originalFetch = window.fetch;

window.fetch = async function (...args: Parameters<typeof fetch>) {
  const response = await originalFetch(...args);

  // 1. Sesión deslizante: renovar el token silenciosamente si vino uno nuevo
  const nuevoToken = response.headers.get('X-New-Token');
  if (nuevoToken) {
    localStorage.setItem('token', nuevoToken);
  }

  // 2. Red de seguridad: si el token de verdad venció o es inválido
  const primerArg = args[0];
  const url = typeof primerArg === 'string' ? primerArg : (primerArg as Request).url;
  const esIntentoDeLogin = url.includes('/auth/login');

  if (response.status === 401 && !esIntentoDeLogin) {
    localStorage.removeItem('token');
    localStorage.removeItem('nombre');

    if (!window.location.pathname.startsWith('/login')) {
      sessionStorage.setItem('sesion_expirada', '1');
      window.location.href = '/login';
    }
  }

  return response;
};

export {};
